export type ReservationAvailabilityDisableReasonLevel = 'warning' | 'error';

export type ReservationAvailabilityDisableReason = {
  level: ReservationAvailabilityDisableReasonLevel;
  message: string;
};

export function createAvailabilityDisableReason(
  message: string,
  level: ReservationAvailabilityDisableReasonLevel
): ReservationAvailabilityDisableReason {
  return { level, message };
}

export function hasErrorAvailabilityDisableReason(reasons: readonly ReservationAvailabilityDisableReason[]): boolean {
  return reasons.some((reason) => reason.level === 'error');
}
